export function getAllowedVisibilities(organization) {
  return organization?.metadata?.['envelope.allowed_visibilities'] ?? [];
}

export function getVisibilityOptions({ visibilities, teams, translate }) {
  const options = [];
  if (visibilities.includes('private')) {
    options.push({
      value: 'private',
      label: translate('modal.envelope.review.visibilityOptions.private'),
    });
  }
  if (visibilities.includes('organization')) {
    options.push({
      value: 'organization',
      label: translate('modal.envelope.review.visibilityOptions.organization'),
    });
  }
  if (visibilities.includes('team')) {
    const prefix = translate(
      'modal.envelope.review.visibilityOptions.teamLabel'
    );
    teams.forEach((team) => {
      options.push({
        value: `team:${team.id}`,
        label: `${prefix} | ${team.name}`,
      });
    });
  }
  return options;
}

export function getCurrentVisibilityValue(envelope) {
  if (!envelope?.visibility) {
    return null;
  }
  if (envelope.visibility === 'team' && envelope.team) {
    return `team:${envelope.team}`;
  }
  return envelope.visibility;
}
